export const PV_SCAN_QR_CODE = 'PV_SCAN_QR_CODE';
export const PV_SCAN_QR_CODE_EVENT = 'PV Scan QR Code';
